import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';

// Console easter egg
console.log(`
                           🔒 THE CISO NETWORK 🔒

                                                                           
                                  *******                                  
                              ***************                              
                         *************************                         
                    ***********************************                    
               *********************   *********************               
            *******************             *******************            
            **************                       **************            
            *********                                 *********            
            ******                                       ******            
            ******                                       ******            
                                                                           
            ++++++++++     ++++    ++++++++++       +++++++++++            
          ++++++++++++++   ++++   +++++++++++++    ++++++++++++++          
          +++++     ++++   ++++  +++++     ++++   +++++     +++++          
         ++++        ++++  ++++  ++++++     ++++  ++++        ++++         
         ++++              ++++   +++++++++++     ++++  ++++  ++++         
         ++++              ++++     +++++++++++   ++++  ++++  ++++         
         ++++        ++++  ++++  ++++     ++++++  ++++   ++   ++++         
         +++++      +++++  ++++  ++++       ++++  +++++      +++++         
          ++++++++++++++   ++++  +++++++++++++++  +++++++++++++++          
           ++++++++++++    ++++    ++++++++++++     ++++++++++++           
               ++++                   ++++              ++++               
             ********                                 ********             
              ********                               ********              
               ********                             ********               
                *********                         *********                
                  *********                     *********                  
                   **********                 **********                   
                     **********             **********                     
                       ***********       ***********                       
                        ************* *************                        
                           *********************                           
                             *****************                             
                                ***********                                
                                   *****                                   
                                                                           
                                                                           
                                                                               
    👋 Hey there, curious person!
    
    Like what you see? We're always on the lookout for 
    talented folks to join our elite network of CISOs.
    
    Why not pop over to /careers and see if there's 
    something that tickles your fancy?
    
    No nonsense. Just good people doing important work.
    
    - The CISO Network Team
`);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
